export default "__VITE_ASSET__BMbFdweS__"